import React from "react";
import { Link } from "react-router-dom";

const MerchantListItem = (props) => {
  return (
    <Link className="table-row" to={`/merchant/${props.merchant.id}`}>
      <div className="table-cell">{props.merchant.name}</div>
      <div className="table-cell">{props.merchant.number}</div>
    </Link>
  );
};

export default MerchantListItem;
